var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"width":"60%","title":_vm.title},on:{"closed":function($event){return _vm.$emit('closed')}}},[_c('ObjectTree',{attrs:{"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }